import { render, staticRenderFns } from "./Slidetxt.vue?vue&type=template&id=9a45c1c6&scoped=true"
import script from "./Slidetxt.vue?vue&type=script&lang=js"
export * from "./Slidetxt.vue?vue&type=script&lang=js"
import style0 from "./Slidetxt.vue?vue&type=style&index=0&id=9a45c1c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a45c1c6",
  null
  
)

export default component.exports